module.exports = __webpack_public_path__ + "img/service-01.823db29d.png";